import { Theme } from "@material-ui/core";
import createStyles from "@material-ui/core/styles/createStyles";

export const styles = ({spacing, breakpoints}: Theme) => createStyles({

    header: {
        paddingLeft: 0,
        "& h2": {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            fontWeight: 400
        }
    },
    content: {
        padding: spacing.unit * 6,
    },
    popin: {
        [breakpoints.down(900)]: {
            marginLeft: 48,
            marginRight: 48
        }
    }
});


// WEBPACK FOOTER //
// ./src/components/Popin/Popin.style.tsx